import styled from "styled-components";

export const PageWrapper = styled.div`

  font-family: "Outfit", sans-serif;

.PageWrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff9eb;
}

.verification-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.verification-box {
  background: #ffffff;
  padding: 40px 30px;
  border-radius: 20px;
  box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.verification-box:hover {
  transform: translateY(-5px);
  box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.15);
}

.icon-wrapper {
  font-size: 50px;
  margin-bottom: 20px;
  color: #ee2d2f;
}

.icon-wrapper.success {
  color: #4caf50;
}

.content {}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.message {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
}

.progress {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.emailverification-logo {
    margin-bottom: 30px;
    border-bottom: 1px solid #cccccc40;
    padding-bottom: 15px;
}

.emailverification-logo svg {
    width: 100px;
}

`;
